import React from 'react';
// import './index.scss';
import { render, ReactDOM } from 'react-dom';
import { Provider } from 'react-redux';
import { store } from './stores/rootStore';
import { App } from '../src/views/App';
import environment from 'environment';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

// setup fake backend
import { configureFakeBackend } from './stores/_helpers';
configureFakeBackend();

render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('app')
);
// import 'react-app-polyfill/ie11';
// import 'react-app-polyfill/stable';

// import './index.scss';

// import React from 'react';
// import ReactDOM from 'react-dom';
// import { Provider } from 'react-redux';
// import { createBrowserHistory } from 'history';
// import * as rootStore  from './stores/rootStore';
// import  { App } from '../src/views/App';
// import environment from 'environment';

// (async (window) => {
//   const initialState = {};
//   const history = createBrowserHistory({ basename: environment.route.baseRoute });
//   const store = rootStore(initialState, history);

//   const rootEl = document.getElementById('root');
//   const render = (Component, el) => {
//     ReactDOM.render(
//       <Provider store={store}>
//         <Component history={history} dispatch={store.dispatch} />
//       </Provider>,
//       el
//     );
//   };

//   render(App, rootEl);
// })(window);
